import { Box, IconButton, Tooltip, tooltipClasses } from '@mui/material';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { Copy } from 'lucide-react';
import { cutUID } from '~/utils/string';

type IdFieldProps = {
    id: string;
    label?: string;
    typographyProps?: TypographyProps;
};

export default function IdField({ id, label, typographyProps }: IdFieldProps) {
    const copyToClipboard = () => {
        navigator.clipboard.writeText(id);
    };

    return (
        <Box display="flex" alignItems="center" gap={0.25}>
            <Typography fontSize={12} lineHeight={1.2} {...typographyProps}>{`${
                label ? `${label}:` : ''
            } ${cutUID(id)}`}</Typography>
            <Tooltip
                PopperProps={{
                    sx: {
                        [`& .${tooltipClasses.tooltip}`]: {
                            maxWidth: 'none',
                        },
                    },
                }}
                title={id}
                placement="right"
            >
                <IconButton
                    size="small"
                    color="primary"
                    sx={{ my: -2 }}
                    onClick={copyToClipboard}
                >
                    <Copy size={10} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
